// import Cookie from 'vue-cookie'
import { encrypt, decrypt } from './md'

export const setCookie = (name, data) => {
  return sessionStorage.setItem(name, data)
}

export const getCookie = (name) => {
  return sessionStorage.getItem(name)
}

export const reSetCookie = (name) => {
  return new Promise(resolve => {
    sessionStorage.removeItem(name)
    resolve()
  })
}

export const setLocal = (name, data) => {
  return localStorage.setItem(encrypt(name), encrypt(data))
}

export const getLocal = (name) => {
  if (localStorage.getItem(encrypt(name))) {
    return decrypt(localStorage.getItem(encrypt(name)))
  } else {
    return ''
  }
}

export const reSetLocal = (name) => {
  return new Promise(resolve => {
    localStorage.removeItem(encrypt(name))
    resolve()
  })
}

// // 保存数据到 sessionStorage
// sessionStorage.setItem('key', 'value');

// // 从 sessionStorage 获取数据
// let data = sessionStorage.getItem('key');

// // 从 sessionStorage 删除保存的数据
// sessionStorage.removeItem('key');

// // 从 sessionStorage 删除所有保存的数据
// sessionStorage.clear();

// import { encrypt, decrypt } from './md'

// export const setCookie = (name, data) => {
//   console.log(encrypt(name), encrypt(data))
//   return sessionStorage.setItem(encrypt(name), encrypt(data))
// }

// export const getCookie = (name) => {
//   if (sessionStorage.getItem(encrypt(name))) {
//     return decrypt(sessionStorage.getItem(encrypt(name)))
//   } else {
//     return ''
//   }
// }

// export const reSetCookie = (name) => {
//   return new Promise(resolve => {
//     sessionStorage.removeItem(encrypt(name))
//     resolve()
//   })
// }

// export const setLocal = (name, data) => {
//   return localStorage.setItem(encrypt(name), encrypt(data))
// }

// export const getLocal = (name) => {
//   if (localStorage.getItem(encrypt(name))) {
//     return decrypt(localStorage.getItem(encrypt(name)))
//   } else {
//     return ''
//   }
// }

// export const reSetLocal = (name) => {
//   return new Promise(resolve => {
//     localStorage.removeItem(encrypt(name))
//     resolve()
//   })
// }
